import { Controller } from "@hotwired/stimulus";
import { dropzoneElement } from "../../components/dropzone";

export default class extends Controller {
  static targets = ["fileSelectionContainer", "fileSelectionForm", "fileUploadContent"];

  connect() {
    window.$(this.element).on("show.bs.modal", () => {
      this._resetModal();
    });
  }

  _resetModal() {
    this.fileSelectionContainerTarget.classList.remove("hidden");

    const dropzone = dropzoneElement(this.fileSelectionFormTarget.id);
    dropzone.removeAllFiles(true);
    dropzone.previewsContainer.innerHTML = "";

    this.fileUploadContentTarget.innerHTML = "";
  }

  filesAdded() {
    this.fileSelectionContainerTarget.classList.add("hidden");

    this._reloadPurchasesTable();
  }

  _reloadPurchasesTable() {
    document.dispatchEvent(new CustomEvent("datatable:reload"));
  }
}
